package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.px

val PersonalizedButtonStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(leftRight = 6.px)
            .styleModifier {
                property("height", "35px")
                property("max-width", "100%")
                property("box-sizing", "border-box")
            }
    }

    Breakpoint.MD {
        Modifier
            .padding(leftRight = 8.px)
            .styleModifier {
                property("height", "45px")
            }
    }

    Breakpoint.LG {
        Modifier
            .padding(leftRight = 10.px)
            .styleModifier {
                property("height", "50px")
                property("width", "315px")
                property("max-width", "100%")
            }
    }
}

val PersonalizedIconStyle = CssStyle {
    base {
        Modifier.fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(22.px)
    }
    Breakpoint.LG {
        Modifier.fontSize(24.px)
    }
}

val PersonalizedTextStyle = CssStyle {
    base {
        Modifier
            .styleModifier {
                property("font-size", 14.px)
            }
    }
    Breakpoint.MD {
        Modifier
            .styleModifier {
                property("font-size", 16.px)
            }
    }
    Breakpoint.LG {
        Modifier
            .styleModifier {
                property("font-size", 20.px)
            }
    }
}

val PersonalizedChevronStyle = CssStyle {
    base {
        Modifier.fontSize(14.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
    Breakpoint.LG {
        Modifier.fontSize(18.px)
    }
}

val DropdownItemStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .styleModifier {
                property("height", 40.px)
                property("font-size", 14.px)
                property("transition", "background-color 150ms ease")
            }
    }

    Breakpoint.MD {
        Modifier.styleModifier {
            property("font-size", 18.px)
        }
    }

    hover {
        Modifier.styleModifier {
            property(
                "background-color",
                Colors.LightGray.toString()
            )
        }
    }
}